export default {
  recommandations_pending: false,
  recommandations: []
}
